import type { IClipboard } from './types';

const Clipboard: Readonly<IClipboard> = {
  isAvailable: !!navigator?.clipboard,
  copy: async (text: string) => navigator.clipboard.writeText(text),
} as const;

export default Clipboard;
